/**
 * mh-cart-count-sync.js
 *
 * The site's header cart icon is rendered by a third-party page-builder
 * section (not Dawn's native header), so it doesn't have Dawn's
 * `#cart-icon-bubble` id and never receives Dawn's native AJAX cart-count
 * updates. Without this, the header badge goes stale the moment someone
 * changes quantity or removes a line item from the Cart Drawer (added in
 * this project) without a full page reload.
 *
 * This is a small, additive, read-only sync: it does not touch the header
 * section file at all (which may be regenerated by its page-builder app),
 * it only listens for Dawn's existing 'cart-update' pub/sub event (already
 * published by product-form.js and cart-drawer.js) and refreshes whatever
 * `.cart-count-bubble` badge(s) are present on the page to match the real
 * cart state from /cart.js.
 */
(function () {
  function updateBubbles(itemCount) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var countEl = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (countEl) {
        countEl.textContent = '(' + itemCount + ')';
      }
      bubble.hidden = itemCount === 0;
    });
  }

  function syncFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateBubbles(cart.item_count);
      })
      .catch(function () {
        /* non-critical: leave existing badge state on failure */
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncFromServer();
    });
  }

  document.addEventListener('DOMContentLoaded', syncFromServer);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    syncFromServer();
  }
})();
